(function () {

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });
  }

  subscribe('variant-change', function (eventData) {
    const variant = eventData?.data?.variant;
    if (!variant) return;

    const price = variant.price;
    const compareAtPrice = variant.compare_at_price;

    // ✅ GIFT CARD — straight price
    const giftCardEl = document.getElementById('gift-card-price');
    if (giftCardEl) {
      giftCardEl.textContent = formatMoney(price);
      console.log('✅ Gift card price updated:', formatMoney(price));
      return;
    }

    const priceSpan = document.querySelector('.product-purchase-wrapper span');
    const srpEl = document.getElementById('srp-info');

    // ✅ CLEARANCE — compare_at_price exists and > price
    if (compareAtPrice && compareAtPrice > price) {
      const discountAmount = compareAtPrice - price;
      const discountedPrice = compareAtPrice - discountAmount; // = price

      if (priceSpan) priceSpan.textContent = formatMoney(discountedPrice);
      if (srpEl) srpEl.innerHTML = `SRP ${formatMoney(compareAtPrice)} - Save ${formatMoney(discountAmount)} &nbsp;|&nbsp; <strong>Free Shipping with MF Plus</strong>`;
      console.log('✅ Clearance prices updated');

    } else {
      // ✅ REGULAR — 20% discount
      const discountAmount = price * 0.20;
      const discountedPrice = price - discountAmount;

      if (priceSpan) priceSpan.textContent = formatMoney(discountedPrice);
      if (srpEl) srpEl.innerHTML = `SRP ${formatMoney(price)} - Save ${formatMoney(discountAmount)} &nbsp;|&nbsp; <strong>Free Shipping with MF Plus</strong>`;
      console.log('✅ Regular prices updated');
    }

  });

})();







